/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Flex,
  message,
  Badge,
  Card,
  Select,
  Typography,
  Divider,
  InputNumber,
} from "antd";
import { Row, Col, Space } from "antd";
// import { Upload,Modal } from "antd";
import { SaveFilled, SearchOutlined } from "@ant-design/icons";
import { ButtonBack } from "../../../components/button/index.js";
// import { uploadButton } from "../../../components/button/index.js";
import { useLocation, useNavigate } from "react-router";
import { delay } from "../../../utils/util.js";
// import { BACKEND_URL_MAIN } from "../../../utils/util.js";
// import Swal from "sweetalert2";
import WIservice from "../../../service/ERP/WI.service.js";
import OptionService from "../../../service/ERP/Options.service.js";

import ModalUnit from "../../../components/modal/ERP/unit/ModalUnit.jsx";

const fgservice = WIservice();
const opService = OptionService();
const { Text } = Typography;

const from = "/ERP/wi";

const ItemManage = () => {
  const { TextArea } = Input;
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const isView = config?.action === "view";
  const [form] = Form.useForm();
  // const [formImage] = Form.useForm();
  const [formDetail, setFormDetail] = useState([]);
  const [optionPrefix, setOptionPrefix] = useState([]);
  const [openModalUnit, setOpenModalUnit] = useState(false);
  const [prefixCode, setPrefixCode] = useState(null);
  const [fgCode, setFgCode] = useState("");

  useEffect(() => {
    // setLoading(true);
    GetPrefix();
    if (config?.action !== "create") {
      getsupData(config.code);
    } else {
      form.setFieldValue("net_weight", 1);
      form.setFieldValue("multiply", 1);
    }
    // console.log(config);

    return () => {
      form.resetFields();
    };
  }, []);

  useEffect(() => {
    fnsetWIcode(); // อัปเดตค่า fgCode เมื่อฟอร์มเปลี่ยนแปลง
    // alert(fgCode);
  }, [form.getFieldValue("wi_code")]);

  const fnsetWIcode = () => {
    setFgCode(
      (form.getFieldValue("prefixLabel")!==undefined?form.getFieldValue("prefixLabel") :"") +
      (form.getFieldValue("prefixLabel")!==undefined&&form.getFieldValue("wi_code")!==undefined?"-" :"") + 
      (form.getFieldValue("wi_code")!==undefined?form.getFieldValue("wi_code") :"")
    ); // อัปเดตค่า fgCode เมื่อฟอร์มเปลี่ยนแปลง
  };

  const GetPrefix = () => {
    opService.optionsRuncode({ p: "wi" }).then((res) => {
      let { data } = res.data;
      // let code = data.run_number
      setOptionPrefix(data);
    });
  };

  const handleChoosedUnit = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      unit: value.unitname,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const getsupData = (v) => {
    fgservice
      .get(v)
      .then(async (res) => {
        const { data } = res.data;
        // const { data, file } = res.data;

        const init = {
          ...data,
        };

        setFormDetail(init);
        form.setFieldsValue({ ...init });
        form.setFieldValue("wi_code1", data.wi_code);
      })
      .catch((err) => {
        console.log(err);
        message.error("Error getting infomation WI.");
      });
  };

  const handleConfirm = () => {
    form.validateFields().then(() => {
      const source = {
        ...formDetail,
        ...form.getFieldsValue(),prefixLabel: form.getFieldValue("prefixLabel")
      };
      const actions =
        config?.action !== "create"
          ? fgservice.update(source)
          : fgservice.create(source);

      actions
        .then(async (r) => {
          message.success("Request success.");
          navigate(from, { replace: true });
          await delay(300);
        })
        .catch((err) => {
          console.warn(err);
          const data = err?.response?.data;
          message.error(data?.message || "บันทึกไม่สำเร็จ");
        });
    });
  };

  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };

  const prefixSelector = (
    <Form.Item name="prefixid" noStyle>
      <Select
        style={{
          width: 350,
          textAlign: "left",
          paddingLeft: "10px",
        }}
        onChange={(v, l) => {
          form.setFieldValue("prefixLabel", l.text);
          // หรือเก็บใน state
          setPrefixCode(l.id)
          opService
            .optionsGetLastcode({ p: "packaging", id: v })
            .then((res) => {
              let { data } = res;
              setPrefixCode(data.data);
              const val = {
                ...formDetail,
                prefix: l.text,
              };
              setFormDetail(val);
            });
            fnsetWIcode();
        }}
        options={optionPrefix.map((item) => ({
          value: item.id,
          label: item.value+' - '+item.definition,
          text: item.value,
        }))}
      ></Select>
    </Form.Item>
  );

  let redcode = (
    <>
      {fgCode && fgCode !== "NaN" && (
      <span style={{ paddingLeft: "20px" }}>
        {"ตัวอย่างรหัสใหม่ " + fgCode}
      </span>
    )}
      <span style={{ color: "red", paddingLeft: "10px" }}>
        {prefixCode !== null ? " รหัสล่าสุด " + prefixCode : ""}
      </span>
    </>
  );

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Divider {...dividerProp}>Basic Data</Divider>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action !== "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item
            label={
              <span>
                <span>WI Code</span>
                {redcode}
              </span>
            }
            name="wi_code"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input
              addonBefore={
                <Text
                  style={{
                    width: 150,
                  }}
                >
                  {prefixSelector}
                </Text>
              }
              onChange={() => fnsetWIcode()}
              placeholder="Enter WI Code."
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action === "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="WI Code" name="wi_code1">
            <Input readOnly />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
          <Form.Item
            label="WI Thai Name"
            name="wi_name"
            rules={[{ required: true, message: "โปรดกรอกข้อมูล" }]}
          >
            <Input placeholder="Enter WI Thai Name" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
          <Form.Item label="WI English Name" name="wi_nameEN">
            <Input placeholder="Enter WI English Name" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6} xxl={6}>
          <Form.Item name="code" label="Code">
            <Input placeholder="Enter Code" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item label="หน่วยสินค้า :" name="unit">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Unit"
                value={!!formDetail.unit ? `${formDetail.unit} ` : ""}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalUnit(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>        
      </Row>
      <Divider {...dividerProp}>ข้อมูลใช้คำนวน</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="net_weight" label="Net Weight">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              step="0.01"
              placeholder="Enter Net Weight "
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item
            name="multiply"
            label={
              <span>
                <span>Multiply</span>
                {/* <Text type="secondary">
                  {" (ใชhกับจำนวนการผลิต) "}
                </Text> */}
              </span>
            }
          >
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              step="0.01"
              placeholder="Enter Multiply "
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider {...dividerProp}>Other Data</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={4}
          style={
            config.action === "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="สถานะการใช้งาน" name="active_status">
            <Select
              size="large"
              options={[
                {
                  value: "เปิดการใช้งาน",
                  label: <Badge status="success" text="เปิดการใช้งาน" />,
                },
                {
                  value: "ปิดการใช้งาน",
                  label: <Badge status="error" text="ปิดการใช้งาน" />,
                },
              ]}
            />
          </Form.Item>
        </Col>
        {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="feature" label="Feature">
            <TextArea rows={4} placeholder="Enter Feature" />
          </Form.Item>
        </Col> */}
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="remarks" label="Remark">
            <TextArea rows={4} placeholder="Enter Remark " />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!isView && (
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              บันทึก
            </Button>
          )}
        </Flex>
      </Col>
    </Row>
  );
  return (
    <div className="fg-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space direction="vertical" className="flex gap-2">
        <Form
          form={form}
          name="form_in_modal_add"
          layout="vertical"
          autoComplete="off"
          initialValues={{
            modifier: "public",
          }}
          disabled={isView}
        >
          <Card title={config?.title}>{Detail}</Card>
        </Form>
        {SectionBottom}
      </Space>

      {openModalUnit && (
        <ModalUnit
          show={openModalUnit}
          close={() => {
            setOpenModalUnit(false);
          }}
          values={(v) => {
            handleChoosedUnit(v);
          }}
        ></ModalUnit>
      )}
    </div>
  );
};

export default ItemManage;
